import isBreakpoint from '~scripts/utility/media-query';
import _debounce from 'lodash.debounce';

const desktopNavFunction = () => {
  document.addEventListener(

    'mouseover',
  
    (e) =>
  
      e.target.matches('.navbar__link') &&
  
      // [...document.querySelectorAll('.navbar__link--active')].map((el) =>
  
      //   el.classList.remove('navbar__link--active')
  
      // ) &&
  
          e.target.classList.add('navbar__link--active')
  
  );
  
  // document.addEventListener(
  
  //   'mouseover',
  
  //   (e) =>
  
  //     !e.target.matches('.navbar__link') &&
  
  //         !e.target.closest('.navbar__link') &&
  
  //         [...document.querySelectorAll('.navbar__link--active')].map((el) => el.classList.remove('navbar__link--active'))
  
  // );
  
  document.addEventListener('mouseover', ({ target }) => {
    if (target.matches('.navbar__link') || target.closest('.navbar__link')) return;
  
    [...document.querySelectorAll('.navbar__link--active')].map((el) => {
      if (!el.nextElementSibling) return;
      if (!el.nextElementSibling.matches('.navbar__children')) return;
  
      const timer = setTimeout(() => {
        el.classList.remove('navbar__link--active');
      }, 250);
  
      el.addEventListener('mouseover', () => {
        clearTimeout(timer);
      });
  
      el.nextElementSibling.addEventListener('mouseover', () => {
        clearTimeout(timer);
      });
    });
  });
};

const mobileNavFunction = () => {
  // Add click event to remove active class
  document.addEventListener('click', (e) => {
    if (e.target.matches('.navbar__link')) {
      // If the clicked link already has the active class, remove it
      if (e.target.classList.contains('navbar__link--active')) {
        e.target.classList.remove('navbar__link--active');
      } else {
        // Otherwise, add the active class to the clicked link
        e.target.classList.add('navbar__link--active');
      }
    } 
  });
};

const NavigationSettings = {
  _currentBreakpoint: 'desktop',

  handleResize() {
    this._currentBreakpoint = isBreakpoint('mobile')
      ? 'mobile'
      : 'desktop'
    ;

    if (isBreakpoint('mobile')) {
      if (this._currentBreakpoint === 'mobile') {
        // No breakpoint change, do nothing
        return mobileNavFunction();
      }     

      this._currentBreakpoint = 'mobile';
    } else {
      if (this._currentBreakpoint === 'desktop') {
        // No breakpoint change, do nothing
        return desktopNavFunction();
      }
      
      this._currentBreakpoint = 'desktop';
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  NavigationSettings.handleResize(); // Check the size on initial load
});

window.addEventListener('resize', _debounce(() => {
  NavigationSettings.handleResize();
}, 200));


const classToggle = (el, cls) => el.classList[el.matches(`.${cls}`) ? 'remove' : 'add'](cls);

document.addEventListener(

  'click',

  ({ target }) => target.matches('.hamburger') && classToggle(document.querySelector('.navbar'), 'navbar--active')

);

// Height Transition

const menuTransitionFix = () => {
  const navbar = document.querySelector('.navbar');

  const menu = navbar.querySelector('.navbar__bottom');

  const menuActive = navbar.matches('.navbar--active');  

  let style = document.querySelector('#menu-transition-styling');

  if (style) style.innerText = '';

  if (!menuActive) navbar.classList.add('navbar--active');

  const height = menu.getBoundingClientRect().height;

  if (!menuActive) navbar.classList.remove('navbar--active');

  const css = `.navbar--active .navbar__bottom {height:${height}px}`;

  if (style) {
    return (style.innerText = css);
  } else {
    style = document.createElement('style');

    style.id = 'menu-transition-styling';

    style.innerText = css;

    return document.head.appendChild(style);
  }
};

document.addEventListener('DOMContentLoaded', menuTransitionFix);

window.addEventListener('resize', menuTransitionFix);
